import { Table, TableProps } from 'antd';
import React from 'react';
interface AntdTableProps extends TableProps {}
export const AntdTable = (props: AntdTableProps) => {
    return (
        <div className="stock-antd-table">
            <Table {...props} />
        </div>
    );
};
